
import {Component} from '@angular/core'
import {ReportModel} from '../../insa-models'
import {InsaService, LocalizeService} from '../../insa-services'
import {appStateProvider} from '../../insa-providers'

@Component({
    selector: 'insa-portfolioOverview',
    template: "<h2 id='info'>{{selectedPortfolios}}  {{startDate | date:'dd.MM.y'}} - {{endDate| date:'dd.MM.y'}}</h2>"
})

export class PortfolioOverviewComponent{
   private reportSubscription;
   private startDate: Date;
   private endDate: Date;
   private selectedPortfolios;

    constructor(private _appStateProvider: appStateProvider, private _insaService:InsaService, private _localize: LocalizeService) {
         this.reportSubscription = this._insaService.CreateReportEvent.subscribe(rep=>this.refreshReport(rep));
    }

  private refreshReport(report: ReportModel){
    let multiSelectBox: kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
    if (report !== null && report!==undefined) {
      this.startDate = report.StartDate;
      this.endDate = report.EndDate;
    } else {
      this.startDate = new Date(new Date().getFullYear() - 1, 11, 31);
      this.endDate = new Date();
    }
     if(multiSelectBox!==undefined){
      if (multiSelectBox.dataItems().length === 0) {
        this.selectedPortfolios ="n/a"
      } else if (multiSelectBox.dataItems().length > 1) {
         this.selectedPortfolios = this._localize.getLocalizedResource("Res892")
      } else {
        this.selectedPortfolios = multiSelectBox.dataItems()[0].Number;
      }
     }
 }

  ngOnInit(){
    this.startDate = new Date(new Date().getFullYear() - 1, 11, 31);
    this.endDate = new Date();
  }

  ngOnDestroy(){
      this.reportSubscription.unsubscribe();
  }     
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-settings-and-tiles/portfolio-overview.component.ts